export default "__VITE_ASSET__D40DhXzL__"